import * as L from 'leaflet';
import "leaflet-routing-machine";
import * as cors from 'corslite';
import { delay } from 'rxjs/operators';

export class DPTomTom {
   private  options= {
    serviceUrl: "https://api.tomtom.com/routing/1/calculateRoute",
    timeout: 180 * 1000,
    routeType: "fastest", // fastest, shortest, eco, thrilling
    language: "", // en-GB
    instructionsType: "", // coded, text, tagged
    traffic: false,
    avoid: "", // [tollRoads, motorways, ferries, unpavedRoads, carpools, alreadyUsedRoads]
    travelMode: "car", // car, truck, taxi, bus, van, motorcycle, bicycle, pedestrian
    vehicleMaxSpeed: 0, // km/h
    vehicleWeight: 0, // kg
    vehicleAxleWeight: 0, // kg
    vehicleLength: 0, // m
    vehicleWidth: 0, // m
    vehicleHeight: 0, // m
    departAt: "", // YYYY-MM-DD\THH:mm:ss
    arriveAt: "", // YYYY-MM-DD\THH:mm:ss
    vehicleCommercial: false,
    computeBestOrder:false,
   }
    private apiKey:string;
   

    private initialize = () =>{
        L.Util.setOptions(this, this.options);
    }

    getTomTomRouting(apiKey:string,options:any) {
        this.apiKey = apiKey;
        const {travelMode , routeType, avoid} = options;
        const localOptions = {...this.options}
        this.options = {
            ...localOptions,
            travelMode,
            routeType,
            avoid
        }
        L.Routing['TomTom'] =  L.Class.extend({
                options:this.options,
                intialize: this.initialize,
                route:this.route,
                buildRouteUrl:this.buildRouteUrl
            });
           
        return new L.Routing['TomTom']();
    }
    route = (waypoints:any,callback:any,context:any,options:any) =>{
      
        let timedOut = false,
            wps = [],
            url:string,
            timer:any,
            wp;
            delay(3000);
            options = options || {};
            url = this.buildRouteUrl(waypoints);
           
            timer = setTimeout(function() {
                                timedOut = true;
                                callback.call(context || callback, {
                                    status: -1,
                                    message: 'TomTom request timed out.'
                                });
                            }, this.options.timeout);

            // Create a copy of the waypoints, since they
            // might otherwise be asynchronously modified while
            // the request is being processed.
            for (let i = 0; i < waypoints.length; i++) {
                wp = waypoints[i];
                wps.push({
                    latLng: wp.latLng,
                    name: wp.name,
                    options: wp.options
                });
            }

            cors(url, (err:any,resp:any) => {
                let data;
                clearTimeout(timer);
                if (!timedOut) {
                    if (!err) {
                        data = JSON.parse(resp.responseText);
                        this.routeDone(data, wps, callback, context);
                    } else {
                        callback.call(context || callback, {
                            status: -1,
                            message: 'HTTP request failed: ' + JSON.parse(err.responseText).error.description
                        });
                    }
                }
            });
            return this;
    }
    buildRouteUrl(waypoints:any) { 
        let locs = [],
            localOptions = Object.assign({},this.options);
            delete localOptions.serviceUrl;
            delete localOptions.timeout;

            if (localOptions.avoid == "")
                delete localOptions.avoid;

            if (localOptions.instructionsType == "")
                delete localOptions.instructionsType;

            if (localOptions.language == "")
                delete localOptions.language;

            if (localOptions.departAt.match(/^(\d{4})\-(\d{2})\-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/) === null)
                delete localOptions.departAt;

            if (localOptions.arriveAt.match(/^(\d{4})\-(\d{2})\-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/) === null)
                delete localOptions.arriveAt;
            
            if(localOptions.travelMode === "")
                localOptions.travelMode = 'car';
            
            if(localOptions.routeType === "")
               localOptions.routeType = "fastest";
               

            for (let i = 0; i < waypoints.length; i++) {
                locs.push(waypoints[i].latLng.lat + ',' + waypoints[i].latLng.lng); }
                delay(10000*2)
            return this.options.serviceUrl + '/' + locs.join(':') + '/json?key=' +
                    this.apiKey + '&' + Object.keys(localOptions).map(function(k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(localOptions[k])
                    }).join('&');

    }
    private routeDone(response:any, inputWaypoints:any, callback:any, context:any){
        delay(10000);
        let alts = [],
        coordinates = [],
        summary = [],
        index = 0;

        context = context || callback;
        if (response.error && response.error.description) {
            callback.call(context, {
                status: -1,
                message: response.error.description
            });
            return;
        }

        for (let i = 0; i < response.routes[0].legs.length; i++) {
            const path = response.routes[0].legs[i];
            coordinates = coordinates.concat(this.decodePolyline(path.points));
            index += (path.points.length - 1);
            summary.push({ summary: path.summary, index: index });
        }

        let instructions = this.convertInstructions(summary);
        let mappedWaypoints = this.mapWaypointIndices(inputWaypoints, instructions, coordinates);

        alts = [{
            name: '',
            coordinates: coordinates,
            instructions: instructions,
            summary: this.convertSummary(summary),
            inputWaypoints: inputWaypoints,
            actualWaypoints: mappedWaypoints.waypoints,
            waypointIndices: mappedWaypoints.waypointIndices
        }];

        callback.call(context, null, alts);
    }
    private decodePolyline(geometry) {
        let coords = geometry,
            latlngs = new Array(coords.length);

        for (let i = 0; i < coords.length; i++) {
            latlngs[i] = new L.LatLng(coords[i].latitude, coords[i].longitude);
        }

        return latlngs;
    }


    private convertInstructions(summaries) {
        let result = [];

        // tomtom don't provide any instructions, but we will create instructions from summary
        for (let i = 0; i < summaries.length; i++) {
            result.push({ distance: summaries[i].summary.lengthInMeters,
                          time: summaries[i].summary.travelTimeInSeconds,
                          type: (i == summaries.length - 1 ? "DestinationReached" : "WaypointReached"),
                          index: summaries[i].index });
        }

        return result;
    }

    private convertSummary(summaries) {
        let result = { 
                totalDistance: 0,
                totalTime: 0 
            };

        for (let i = 0; i < summaries.length; i++) {
            result.totalDistance += summaries[i].summary.lengthInMeters;
            result.totalTime += summaries[i].summary.travelTimeInSeconds;
        }

        return result;
    }

    private mapWaypointIndices(waypoints, instructions, coordinates) {
        let wps = [],
            wpIndices = [];

        wpIndices.push(0);
        wps.push({ latLng: coordinates[0], name: waypoints[0].name });

        for (let i = 0; i < instructions.length; i++) {
            if (instructions[i].type === "WaypointReached") {
                let idx = instructions[i].index;
                wpIndices.push(idx);
                wps.push({
                    latLng: coordinates[idx],
                    name: waypoints[wps.length + 1].name
                });
            }
        }

        wpIndices.push(coordinates.length - 1);
        wps.push({
            latLng: coordinates[coordinates.length - 1],
            name: waypoints[waypoints.length - 1].name
        });

        return {
            waypointIndices: wpIndices,
            waypoints: wps
        };
    }
    
}
